/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {SettlementsViewComponent} from './settlements-view.component';
import {CommonModule} from '@angular/common';
import {BundleSettlementsTableModule} from '../bundle-settlements-table/bundle-settlements-table.module';
import {PeriodTypeInfoChartModule} from '../shared/components/period-type-info-chart/period-type-info-chart.module';

@NgModule({
    imports: [CommonModule, BundleSettlementsTableModule, PeriodTypeInfoChartModule],
    declarations: [SettlementsViewComponent],
    exports: [SettlementsViewComponent]
})

export class SettlementsViewModule {
}
